import React from "react";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { PortalCaption, PortalKicker, PortalSectionTitle, PortalSurface, portalColors } from "./BusinessPortalComponents";

export const PortalSideNav = styled(PortalSurface)`
    width: 17rem;
    min-width: 17rem;
    max-width: 17rem;
    flex: 0 0 17rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;

    @media (max-width: 980px) {
        width: 100%;
        min-width: 0;
        max-width: 100%;
        flex-basis: auto;
    }
`;

export const PortalSideNavList = styled.div`
    display: grid;
    gap: 0.5rem;
    margin-top: ${p => p.marginTop || "1rem"};
`;

const sideNavItemStyles = css`
    display: grid;
    grid-template-columns: 1.85rem minmax(0, 1fr);
    gap: 0.65rem;
    align-items: center;
    min-height: 3.15rem;
    width: 100%;
    padding: 0.65rem;
    color: ${p => p.$active ? portalColors.text : portalColors.mutedText};
    background: ${p => p.$active ? portalColors.blueSoft : "transparent"};
    border: 1px solid ${p => p.$active ? portalColors.borderStrong : "transparent"};
    border-radius: 8px;
    box-sizing: border-box;
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.82rem;
    font-weight: ${p => p.$active ? 800 : 700};
    line-height: 1.25;
    text-align: left;
    text-decoration: none;
    cursor: ${p => p.disabled ? "not-allowed" : "pointer"};
    opacity: ${p => p.disabled ? 0.55 : 1};
    transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease;

    &:hover {
        color: ${portalColors.text};
        background: ${portalColors.surfaceSoft};
        border-color: ${portalColors.border};
    }

    &:focus-visible {
        outline: 2px solid ${portalColors.text};
        outline-offset: 2px;
    }
`;

export const PortalSideNavLink = styled(Link)`
    ${sideNavItemStyles}
`;

export const PortalSideNavButton = styled.button`
    ${sideNavItemStyles}
`;

export const PortalSideNavIcon = styled.span`
    width: 1.85rem;
    height: 1.85rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${p => p.$active ? "var(--calendar-bg, #FFFFFF)" : portalColors.mutedText};
    background: ${p => p.$active ? portalColors.text : portalColors.surfaceSoft};
    border: 1px solid ${p => p.$active ? portalColors.text : portalColors.border};
    border-radius: 999px;
    box-sizing: border-box;
    overflow: hidden;

    img {
        width: 1.05rem;
        height: 1.05rem;
        object-fit: contain;
        filter: ${p => p.$active ? "brightness(0) invert(1)" : "none"};
    }
`;

export const PortalSideNavText = styled.span`
    min-width: 0;
`;

export function PortalSideNavHeader(props) {
    const { kicker, title, description } = props;

    return (
        <>
            {kicker && <PortalKicker>{kicker}</PortalKicker>}
            {title && <PortalSectionTitle>{title}</PortalSectionTitle>}
            {description && <PortalCaption>{description}</PortalCaption>}
        </>
    );
}
